// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3a2GMWMS","btn-icon":"_3J7PozEP","no-margin":"_2VFRD1un"};